<template>
     <div class="dTBodyRow" @click="showOrchestrationEventDetailPanel(orchItem)">
        <div class="dCell" :class="orchItem.index === selectedOrchEventItem.index && orchestrationEventDetailPanel ? 'active' : ''">
            <strong>{{orchItem.index ? orchItem.index : '-'}}</strong>
        </div>
        <div class="dCell" :class="orchItem.index === selectedOrchEventItem.index && orchestrationEventDetailPanel ? 'active' : ''">
            <strong>{{orchItem.MessageId ? orchItem.MessageId : '-'}}</strong>
        </div>
        <div class="dCell" :class="orchItem.index === selectedOrchEventItem.index && orchestrationEventDetailPanel ? 'active' : ''">
            <strong>{{orchItem.MessageType ? orchItem.MessageType : '-'}}</strong>
        </div>
        <div class="dCell" :class="orchItem.index === selectedOrchEventItem.index && orchestrationEventDetailPanel ? 'active' : ''">
            <!-- <strong>{{orchItem.SourceName}}</strong> -->
            <span class="sourceAlignment resDetailSource" :class="orchItem.SourceName"></span>
        </div>
        <div class="dCell" :class="orchItem.index === selectedOrchEventItem.index && orchestrationEventDetailPanel ? 'active' : ''">
            <strong>{{orchItem.ModuleDetail ? orchItem.ModuleDetail : '-'}}</strong>
        </div>
        <div class="dCell" :class="orchItem.index === selectedOrchEventItem.index && orchestrationEventDetailPanel ? 'active' : ''">
            <strong>
            {{orchItem.CreatedDate ? formattedDate(orchItem.CreatedDate) : '-'}}
            </strong>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
export default {
    name: 'orchestrationEventItem',
    props: ['orchItem', 'selectedOrchEventItem', 'orchestrationEventDetailPanel', 'showOrchestrationEventDetailPanel', 'dateFormatToDisplay'],
    data() {
        return {
            responseTextsList : [{responseText: 'OK', responseCode: 200, className: 'response-ok'}, {responseText: 'ERR', responseCode: 500, className: 'server-error'}, {responseText: 'ERR', responseCode: 400, className: 'client-error'}]
        }
    },
    methods: {
      formattedDate(dateString) {
        return this.dateFormatToDisplay === 'utc' ? moment(dateString).utc().format('DD MMM YYYY hh:mm:ss A') : moment(dateString).local().format('DD MMM YYYY hh:mm:ss A');

      },
      getResponseText(code) {
        return this.responseTextsList.filter(eachItem => eachItem.responseCode == code)[0]
      }
    },

}
</script>
<style scoped>
.sourceAlignment{
    margin: 0px 0px 0 0 !important;
}
.active {
    background: #f0f3fb !important;
}
</style>